import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useCart } from '../context/CartContext';
import useSEO from '../hooks/useSEO';
import logo from '../logo.jpg';
import './Home.css';
import './Carrito.css';
import './Login.css';

const Login = () => {
  useSEO({
    title: 'Iniciar sesión | MiEstampita',
    description: 'Iniciá sesión o creá una cuenta en MiEstampita.',
    path: '/login',
    noindex: true,
  });

  const navigate = useNavigate();
  const { login, register } = useAuth();
  const { refresh } = useCart();

  const [mode, setMode] = useState('login'); // 'login' | 'register'
  const [nombre, setNombre] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    setSubmitting(true);
    try {
      if (mode === 'login') {
        await login({ email, password });
      } else {
        await register({ nombre, email, password });
      }
      await refresh();
      navigate('/carrito');
    } catch (submitError) {
      setError(submitError.message || 'Ocurrió un error.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="home-page">
      <div className="logo-wrapper">
        <Link to="/">
          <img src={logo} alt="MiEstampita Logo" className="logo" />
        </Link>
      </div>
      <div className="home-wrapper login-page">
        <h1 className="selected-title">{mode === 'login' ? 'Iniciar sesión' : 'Crear cuenta'}</h1>

        <form className="login-form" onSubmit={handleSubmit}>
          {mode === 'register' && (
            <>
              <label htmlFor="nombre">Nombre</label>
              <input
                id="nombre"
                type="text"
                value={nombre}
                onChange={(event) => setNombre(event.target.value)}
                required
              />
            </>
          )}

          <label htmlFor="email">Email</label>
          <input id="email" type="email" value={email} onChange={(event) => setEmail(event.target.value)} required />

          <label htmlFor="password">Contraseña</label>
          <input
            id="password"
            type="password"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            minLength={6}
            required
          />

          {error && <p className="cart-cupon__error">{error}</p>}

          <div className="checkout-button-wrapper">
            <button type="submit" className="checkout-button" disabled={submitting}>
              {submitting ? 'Espera...' : mode === 'login' ? 'Iniciar sesión' : 'Crear cuenta'}
            </button>
          </div>
        </form>

        <p className="login-toggle">
          {mode === 'login' ? (
            <>
              ¿No tenés cuenta?{' '}
              <button type="button" className="retry-link" onClick={() => setMode('register')}>
                Creá una
              </button>
            </>
          ) : (
            <>
              ¿Ya tenés cuenta?{' '}
              <button type="button" className="retry-link" onClick={() => setMode('login')}>
                Iniciá sesión
              </button>
            </>
          )}
        </p>
      </div>
    </div>
  );
};

export default Login;
